import React, { useState, useEffect } from "react";
import {
  ButtonBase,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  InputAdornment,
  Link,
} from "@mui/material";
import { StyledTextField } from "../../../common/components/TextField/styles";
import { grey } from "@mui/material/colors";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { faPaperPlane, faPen } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { getComments, addComment } from "../../../api/caseApi";
import { normalizeDateTime } from "../../../common/helpers/normalizeDateTime";
import EditCommentDialog from "./EditCommentDialog";

const CommentSectionDialog = ({ open, onClose, currentCaseProgress }) => {
  console.log(currentCaseProgress);
  let caseProgressAppointmentId = "00000000-0000-0000-0000-000000000000";

  if (
    currentCaseProgress?.caseProgressAppointments &&
    currentCaseProgress?.caseProgressAppointments.length > 0
  ) {
    caseProgressAppointmentId =
      currentCaseProgress?.caseProgressAppointments?.filter((appointment) => {
        return appointment.type.includes("- Main");
      })[0].id;
  }

  useEffect(() => {
    if (open) {
      fetchComments();
    }
  }, [open]);

  const [comments, setComments] = useState([]);
  const fetchComments = async () => {
    const response = await getComments(caseProgressAppointmentId);
    console.log(response.data.data);
    setComments(response.data.data);
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth>
      <DialogTitle>{currentCaseProgress?.type + " - "}Comments</DialogTitle>
      <DialogContent>
        <Grid
          container
          gap={1.5}
          direction="column"
          wrap="nowrap" // --> add this line to disable wrap
          sx={{ maxHeight: "50vh", overflowY: "auto" }}
        >
          {comments.map((comment) => {
            return (
              <Grid item xs={12}>
                <Comment
                  message={comment.message}
                  createdDate={normalizeDateTime(comment.createdDate)}
                  createdBy={comment.createdBy}
                  commentId={comment.id}
                  fetchComments={fetchComments}
                />
              </Grid>
            );
          })}
        </Grid>
        <CommentInput
          caseProgressAppointmentId={caseProgressAppointmentId}
          caseProgressId={currentCaseProgress?.id}
          fetchComments={fetchComments}
        />
      </DialogContent>
    </Dialog>
  );
};

const Comment = ({
  message,
  createdDate,
  createdBy,
  commentId,
  fetchComments,
}) => {
  const [openEditComment, setOpenEditComment] = useState(false);
  return (
    <>
      {" "}
      <EditCommentDialog
        message={message}
        open={openEditComment}
        commentId={commentId}
        onClose={() => setOpenEditComment(false)}
        fetchComments={fetchComments}
      />
      <Grid
        container
        direction={"column"}
        gap={1}
        sx={{
          backgroundColor: "#161616",
          borderRadius: "8px",
          color: "white",
          fontFamily: "Inter",
          fontSize: "14px",
          padding: "10px",
        }}
      >
        <Grid item>{message}</Grid>

        <Grid
          item
          container
          sx={{ fontSize: "12px", color: grey[400] }}
          display={"flex"}
          justifyContent={"space-between"}
        >
          <Grid item> {createdDate + " • " + createdBy}</Grid>
          {createdBy === JSON.parse(localStorage.getItem("user")).email && (
            <Grid item>
              <Link
                onClick={() => setOpenEditComment(true)}
                sx={{ fontSize: "12px", color: grey[400], cursor: "pointer" }}
              >
                <FontAwesomeIcon icon={faPen} /> Edit
              </Link>
            </Grid>
          )}
        </Grid>
      </Grid>
    </>
  );
};

const CommentInput = ({
  caseProgressAppointmentId,
  caseProgressId,
  fetchComments,
}) => {
  const { register, handleSubmit, reset } = useForm({
    resolver: yupResolver(
      yup.object().shape({ message: yup.string().required() })
    ),
  });
  const submitComment = async (values) => {
    await addComment(caseProgressAppointmentId, caseProgressId, values.message);
    await fetchComments(caseProgressAppointmentId);
    reset();
  };
  return (
    <form onSubmit={handleSubmit(submitComment)}>
      <StyledTextField
        label="Comment"
        placeholder="Type your comment here"
        {...register("message")}
        sx={{ width: "100%", marginTop: "20px" }}
        multiline
        rows={2}
        InputProps={{
          endAdornment: (
            <ButtonBase type="submit">
              <InputAdornment>
                <FontAwesomeIcon icon={faPaperPlane} />
              </InputAdornment>
            </ButtonBase>
          ),
        }}
      />
    </form>
  );
};

export default CommentSectionDialog;
